(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.directive('userCardResize', ['$timeout', UsercardResizeFn]);

    /* resize usercards on window size change */
    function UsercardResizeFn($timeout) {
        var directive = {
            link: link,
            scope: {
                cardColumns: "="
            },
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            var timeoutUnbinder = null;

            // bind to window resize and update number of usercard columns on size change
            $(window).bind('resize', function () {
                timeoutUnbinder = $timeout(function () {
                    setUserCardColumns();
                });
            });

            setUserCardColumns();

            // on destroy
            scope.$on('$destroy', function () {
                $(window).unbind('resize');
                if (timeoutUnbinder) {
                    $timeout.cancel(timeoutUnbinder);
                }
            });

            // add div temporarly to find out which viewport is currently used 
            // and update number of usercard columns accordingly
            function setUserCardColumns() {
                var envs = ['xs', 'sm', 'md', 'lg'];

                var $el = $('<div>');
                $el.appendTo($('body'));

                for (var i = envs.length - 1; i >= 0; i--) {
                    var env = envs[i];

                    $el.addClass('hidden-' + env);
                    if ($el.is(':hidden')) {
                        $el.remove();

                        if (env === 'lg') {
                            scope.cardColumns = 4;
                            return;
                        }
                        else if (env === 'md') {
                            scope.cardColumns = 3;
                            return;
                        }
                        else if (env === 'sm') {
                            scope.cardColumns = 2;
                            return;
                        }
                        else {
                            scope.cardColumns = 1;
                            return;
                        }
                    }
                }
            }
        }
    }
})();